import { useMutation, useQueryClient } from '@tanstack/react-query';
import { leadImportApi } from '../api/leadImportApi';
import type { ColumnMapping, ImportPreview, ImportResult } from '../types';

export function useUploadFile() {
  return useMutation<ImportPreview, Error, { formData: FormData; organizationId: string }>({
    mutationFn: async ({ formData, organizationId }) => {
      const { data } = await leadImportApi.uploadFile(formData, organizationId);
      return data;
    },
  });
}

export function useExecuteImport() {
  const queryClient = useQueryClient();

  return useMutation<
    ImportResult,
    Error,
    {
      organizationId: string;
      funnelTemplateId: string;
      assignedTo?: string;
      mappings: ColumnMapping[];
      file: FormData;
    }
  >({
    mutationFn: async (payload) => {
      const { data } = await leadImportApi.executeImport(payload);
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['leads'] });
      queryClient.invalidateQueries({ queryKey: ['board'] });
    },
  });
}

export function useDownloadTemplate() {
  return useMutation<Blob, Error, 'csv' | 'xlsx'>({
    mutationFn: async (format) => {
      const { data } = await leadImportApi.downloadTemplate(format);
      return data;
    },
  });
}
